import React from "react";
import "./index.css";
import BgTransformer from "../../../layout/BgTransformer";
import {useSetting} from "../../../contexts/setting";
import {useBgUrl} from "hooks/useBgUrl";

const StreamYardBackgroundWebinar = ({id, zoom}) => {
  const {type} = useSetting();
  const {url: bgUrl} = useBgUrl();
  return (
    <div id={id} className={`template ${type.value}`} style={{"--zoom-level": zoom}}>
      <div className="template-inner">
        <BgTransformer src={bgUrl} id={id} />
        <div className="content"></div>
      </div>
    </div>
  );
};

export default StreamYardBackgroundWebinar;
